import { render, staticRenderFns } from "./toupbmkj_config.vue?vue&type=template&id=0fd46f0a&scoped=true&"
import script from "./toupbmkj_config.vue?vue&type=script&lang=js&"
export * from "./toupbmkj_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd46f0a",
  null
  
)

export default component.exports